import { createAction, createRequestTypes, FAILURE, REQUEST, RESET, SUCCESS } from '../../../utils/actionGenerator';

export const GET_INDENTS_LIST_T = createRequestTypes('GET_INDENTS_LIST_T');
export const GET_EMAILS_LIST_TICKET = createRequestTypes('GET_EMAILS_LIST_TICKET');

export const SAVE_FILTERS = createRequestTypes('SAVE_FILTERS');
export const RESET_TABLE_TICKET = createRequestTypes('RESET_TABLE_TICKET');
export const UPDATE_TAB = createRequestTypes('UPDATE_TAB');

export const GET_BASIC_DETAILS_TICKET = createRequestTypes('GET_BASIC_DETAILS_TICKET');

export const GET_DETAILS_CONFIG = createRequestTypes('GET_DETAILS_CONFIG');

export const ADD_NEW_TTCKET = createRequestTypes('ADD_NEW_TTCKET');

export const GET_TICKET_DETAILPAGE_DETAILS = createRequestTypes('GET_TICKET_DETAILPAGE_DETAILS');

export const UPDATE_TICKET_DETAILS = createRequestTypes('UPDATE_TICKET_DETAILS');

export const ADD_NEW_COMMENT = createRequestTypes('ADD_NEW_COMMENT');

export const GET_CONVERSATION = createRequestTypes('GET_CONVERSATION');

export const GET_COMMENTS = createRequestTypes('GET_COMMENTS');

export const UNTICK_FLAGS = createRequestTypes('UNTICK_FLAGS');
export const RESET_INDENT_COUNT = createRequestTypes('RESET_INDENT_COUNT');

export const GET_TICKETING_ENTITIES = createRequestTypes('GET_TICKETING_ENTITIES');
export const POST_TICKETING_FIELD = createRequestTypes('POST_TICKETING_FIELD');
export const VIEW_UPLOADED_DOCUMENT2 = createRequestTypes('VIEW_UPLOADED_DOCUMENT2');

export const UPLOAD_DOCUMENTS = createRequestTypes('UPLOAD_DOCUMENTS');
export const GET_STOPPAGE_REASONS = createRequestTypes('GET_STOPPAGE_REASONS');

export const GET_TICKETS_BY_CONSIGNMENT = createRequestTypes('GET_TICKETS_BY_CONSIGNMENT');

export const getIndentsList = {
  request: (params) => createAction(GET_INDENTS_LIST_T[REQUEST], { params }),
  success: (response, params) => createAction(GET_INDENTS_LIST_T[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_INDENTS_LIST_T[FAILURE], { response }),
  resetTable: () => createAction(RESET_TABLE_TICKET),
  saveFilters: (filter) => createAction(SAVE_FILTERS, { filter }),
  updateTab: (value) => createAction(UPDATE_TAB, { value }),
  untickFlags: () => createAction(UNTICK_FLAGS),
};

export const getEmailsList = {
  request: (params) => createAction(GET_EMAILS_LIST_TICKET[REQUEST], { params }),
  success: (response, params) => createAction(GET_EMAILS_LIST_TICKET[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_EMAILS_LIST_TICKET[FAILURE], { response }),
};

export const getBasicDetails = {
  request: (consignmentId) => createAction(GET_BASIC_DETAILS_TICKET[REQUEST], { consignmentId }),
  success: (response) => createAction(GET_BASIC_DETAILS_TICKET[SUCCESS], { response }),
  failure: (response) => createAction(GET_BASIC_DETAILS_TICKET[FAILURE], { response }),
  // resetTable: () => createAction(RESET_TABLE),
  // saveFilters: (filter) => createAction(SAVE_FILTERS, { filter }),
};

export const addNewTicket = {
  request: (payload) => createAction(ADD_NEW_TTCKET[REQUEST], { payload }),
  success: (response) => createAction(ADD_NEW_TTCKET[SUCCESS], { response }),
  failure: (response) => createAction(ADD_NEW_TTCKET[FAILURE], { response }),
};

export const getTicketDetailPageDetails = {
  request: (payload) => createAction(GET_TICKET_DETAILPAGE_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(GET_TICKET_DETAILPAGE_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(GET_TICKET_DETAILPAGE_DETAILS[FAILURE], { response }),
};

export const updateTicketDetails = {
  request: (payload) => createAction(UPDATE_TICKET_DETAILS[REQUEST], { payload }),
  success: (response) => createAction(UPDATE_TICKET_DETAILS[SUCCESS], { response }),
  failure: (response) => createAction(UPDATE_TICKET_DETAILS[FAILURE], { response }),
};

export const addNewComment = {
  request: (payload) => createAction(ADD_NEW_COMMENT[REQUEST], { payload }),
  success: (response) => createAction(ADD_NEW_COMMENT[SUCCESS], { response }),
  failure: (response) => createAction(ADD_NEW_COMMENT[FAILURE], { response }),
};

export const getConversation = {
  request: (payload) => createAction(GET_CONVERSATION[REQUEST], { payload }),
  success: (response) => createAction(GET_CONVERSATION[SUCCESS], { response }),
  failure: (response) => createAction(GET_CONVERSATION[FAILURE], { response }),
};

export const getComments = {
  request: (payload) => createAction(GET_COMMENTS[REQUEST], { payload }),
  success: (response) => createAction(GET_COMMENTS[SUCCESS], { response }),
  failure: (response) => createAction(GET_COMMENTS[FAILURE], { response }),
};

export const getDetailsConfig = {
  request: (payload) => createAction(GET_DETAILS_CONFIG[REQUEST], { payload }),
  success: (response) => createAction(GET_DETAILS_CONFIG[SUCCESS], { response }),
  failure: (response) => createAction(GET_DETAILS_CONFIG[FAILURE], { response }),
};

export const getStoppageReason = {
  request: () => createAction(GET_STOPPAGE_REASONS[REQUEST]),
  success: (response) => createAction(GET_STOPPAGE_REASONS[SUCCESS], { response }),
  failure: (response) => createAction(GET_STOPPAGE_REASONS[FAILURE], { response }),
};

export const getTicketingEntities = {
  request: (payload) => createAction(GET_TICKETING_ENTITIES[REQUEST], { payload }),
  success: (response) => createAction(GET_TICKETING_ENTITIES[SUCCESS], { response }),
  failure: (response) => createAction(GET_TICKETING_ENTITIES[FAILURE], { response }),
};
export const postTicketingFields = {
  request: (payload) => createAction(POST_TICKETING_FIELD[REQUEST], { payload }),
  success: (response) => createAction(POST_TICKETING_FIELD[SUCCESS], { response }),
  failure: (response) => createAction(POST_TICKETING_FIELD[FAILURE], { response }),
};

export const viewUploadedDocument2 = {
  request: (params) => createAction(VIEW_UPLOADED_DOCUMENT2[REQUEST], { params }),
  success: (response, params) => createAction(VIEW_UPLOADED_DOCUMENT2[SUCCESS], { response, params }),
  failure: (response) => createAction(VIEW_UPLOADED_DOCUMENT2[FAILURE], { response }),
};

export const uploadDocument = {
  request: (payload) => createAction(UPLOAD_DOCUMENTS[REQUEST], { payload }),
  success: (response, payload) => createAction(UPLOAD_DOCUMENTS[SUCCESS], { response, payload }),
  failure: (response) => createAction(UPLOAD_DOCUMENTS[FAILURE], { response }),
  reset: () => createAction(UPLOAD_DOCUMENTS[RESET]),
};

export const getTicketsByConsignment = {
  request: (payload) => createAction(GET_TICKETS_BY_CONSIGNMENT[REQUEST], { payload }),
  success: (response, consignmentId) => createAction(GET_TICKETS_BY_CONSIGNMENT[SUCCESS], { response, consignmentId }),
  failure: (error) => createAction(GET_TICKETS_BY_CONSIGNMENT[FAILURE], { error }),
};
